import React from 'react';
import { Badge } from 'react-bootstrap';
import { getListShipmentBadge } from '../../helper/shipment_tracking_helper';

export default function ShipmentTrackingStatusBadge({ order, className = '' }) {
  const badge = getListShipmentBadge(order);
  const classes = ['order-shipment-status-badge', className, badge.className]
    .filter(Boolean)
    .join(' ');

  return (
    <Badge bg={badge.bsVariant || undefined} className={classes}>
      {badge.label}
    </Badge>
  );
}
